import { ClockInGeoMode } from '@sdk/authentication/types';

import { TIME_CLOCK_GEOFENCING_MODES_OPTIONS } from '../../../constants';
import { TimeClockGeofencingModesOption } from '../../../types';

const getGeofencingOptions = (option: ClockInGeoMode): TimeClockGeofencingModesOption[] => {
  return TIME_CLOCK_GEOFENCING_MODES_OPTIONS.reduce((acc, item) => {
    if (option === ClockInGeoMode.onlyClockIn && item.name === option) {
      item.value = true;
      acc.push(item);
      return acc;
    }
    if (option === ClockInGeoMode.onlyClockOut && item.name === option) {
      item.value = true;
      acc.push(item);
      return acc;
    }
    if (option === ClockInGeoMode.both) {
      item.value = true;
      acc.push(item);
      return acc;
    }

    item.value = false;
    acc.push(item);

    return acc;
  }, []);
};

export default getGeofencingOptions;
